// Mappers for user-related entities
// Identity mappers for 1:1 mapping

import type {
  UserProfileDetailsResponseDto,
  GetAllFeatureFlagsResponseDto,
  UserDto,
  ChangePasswordResponseDto,
  PasswordResetResponseDto,
  VerifyPasswordResetResponseDto,
  ResetPasswordResponseDto,
  ConfirmUserInviteResponseDto,
  VerifyEmailResponseDto,
  UserInfoDto,
} from '../../generated/models';

import type { LoginResponse as LoginResponseDto } from '@api/modules/user/types';

import type {
  UserProfileDetailsResponse,
  GetAllFeatureFlagsResponse,
  User,
  ChangePasswordResponse,
  PasswordResetResponse,
  VerifyPasswordResetResponse,
  ResetPasswordResponse,
  ConfirmUserInviteResponse,
  VerifyEmailResponse,
  UserInfo,
  LoginResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toUserProfileDetailsResponse = (dto: UserProfileDetailsResponseDto): UserProfileDetailsResponse => dto;
export const toGetAllFeatureFlagsResponse = (dto: GetAllFeatureFlagsResponseDto): GetAllFeatureFlagsResponse => dto;
export const toUser = (dto: UserDto): User => dto;
export const toChangePasswordResponse = (dto: ChangePasswordResponseDto): ChangePasswordResponse => dto;
export const toPasswordResetResponse = (dto: PasswordResetResponseDto): PasswordResetResponse => dto;
export const toVerifyPasswordResetResponse = (dto: VerifyPasswordResetResponseDto): VerifyPasswordResetResponse => dto;
export const toResetPasswordResponse = (dto: ResetPasswordResponseDto): ResetPasswordResponse => dto;
export const toConfirmUserInviteResponse = (dto: ConfirmUserInviteResponseDto): ConfirmUserInviteResponse => dto;
export const toVerifyEmailResponse = (dto: VerifyEmailResponseDto): VerifyEmailResponse => dto;
export const toUserInfo = (dto: UserInfoDto): UserInfo => dto;
export const toLoginResponse = (dto: LoginResponseDto): LoginResponse => dto;
